import './CategoryCard.css';
import { Link } from 'react-router-dom';
import { TreeNode } from '../../state/categories';
import { useConfig } from '../../config';
import { Store } from '../../config';

export const CategoryCard = ({ category }: { category: TreeNode }): JSX.Element => {
	const { store } = useConfig();
	const categoryImages: Record<Store, Record<number, string>> = {
		kgse: {
			// kontor & papper
			2970000: 'https://images.products.tctc.se/7vc5mc0xdqtwzr4uc92msawvb68uwof9_292_292_tr.webp',
			2650000: '/images/category-card-papper-etiketter.png',
			3290000: 'https://images.products.tctc.se/gcozmh84zgoag9xnzdg595gi4elnocve_292_292_tr.webp',
			3930000: 'https://images.products.tctc.se/8uh5hhgmwuo63r6n3scl4fgkgtlxitvi_292_292_tr.webp',
			3931800: 'https://images.products.tctc.se/2tb512vj51vkjqhms0mztstmvm3pqibs_292_292_tr.webp',
			4250000: 'https://images.products.tctc.se/m78mnngjhztra0q6p5555rf09pbe8zei_292_292_tr.webp',
			4571400: 'https://images.products.tctc.se/hmr3tydlv7ek4qflvcx42ojp3sessxux_292_292_tr.webp',
			4575600: 'https://images.products.tctc.se/yz3lfav8hfiw30m565eq49rvzlktg49y_292_292_tr.webp',
			4890000: 'https://images.products.tctc.se/mb2xxuutp6o4sr5367x6wg5ghqm6ojtb_292_292_tr.webp',
			5214200: 'https://images.products.tctc.se/wise6j46ta4sg5w042kuq96rrypm3evf_292_292_tr.webp',
			6170000: 'https://images.products.tctc.se/acsfv0svll8j6kw34dmqlolkbjtg02as_292_292_tr.webp',
			8111602: 'https://images.products.tctc.se/q0bbdeslm0ghj3o1oxg4sd2n5oujwnxq_292_292_tr.webp',
			8111605: 'https://images.products.tctc.se/gl70jtdzm07bsahvyemd5c3191xqwmh6_292_292_tr.webp',
			8111911: 'https://images.products.tctc.se/vfzl3zqz13pb03o7cur12sfwx4xnmla2_292_292_tr.webp',

			// IT & elektronik
			8110882: 'https://images.products.tctc.se/uuofjtb3wazo4o2q6aismnh9vsfnbwbp_292_292_tr.webp',
			8111880: 'https://images.products.tctc.se/8fyefyhkpr76rwvr2q8o7s42fh7mj7js_292_292_tr.webp',
			2014300: 'https://images.products.tctc.se/va0pba3nnsi0zous6vis7jvpeloj3rkf_292_292_tr.webp',
			8111827: 'https://images.products.tctc.se/1b9mc2w9lnx6xbu5yuchjs7nc4tfb0bs_292_292_tr.webp',
			2010000: 'https://images.products.tctc.se/bldvj38ijyzqqlm2bh0fr51li4rpb71g_292_292_tr.webp',
			4893500: 'https://images.products.tctc.se/yfz52bdbinevqmu544vdvxn8p7gt192j_292_292_tr.webp',
			8111176: 'https://images.products.tctc.se/zxqaxif8wz1fmb54che027pyg38g5zwj_292_292_tr.webp',
			2015700: 'https://images.products.tctc.se/gk9kloysweii7191uymijaylz5ij8ho5_292_292_tr.webp',
			8110618: 'https://images.products.tctc.se/m61qoq5u9ci5vtalo0gmduwlspzuo0cs_292_292_tr.webp',
			8111169: '', // no good images
			4891400: 'https://images.products.tctc.se/4wo7edvmyf9ixsqo5ewugc2e84gjkqk7_292_292_tr.webp',
			2014500: 'https://images.products.tctc.se/yqsvmxl6ucjq55vzq7mo9i2s3lww1ax8_292_292_tr.webp',

			// kaffe, fika & kök
			5212600: 'https://images.products.tctc.se/c3z7tse56ad2nm8adxywju1657qqk72m_292_292_tr.webp',
			8113053: 'https://images.products.tctc.se/qap3slmi228005r07b8pbp2v17ai3qdn_292_292_tr.webp',
			8111834: 'https://images.products.tctc.se/bl4ocd3md3qgzqxbeutc3m9ni8z4zppe_292_292_tr.webp',
			8111832: 'https://images.products.tctc.se/kpwpu89o6iw4dq7e6ylelvvwozmdmcbo_292_292_tr.webp',
			8111833: 'https://images.products.tctc.se/i4q3fsc7y4t00nkeb16cd46v5mrw7qzv_292_292_tr.webp',
			5214400: 'https://images.products.tctc.se/m16k3bc0xnyo22kbdud11uudqfsz3qhh_292_292_tr.webp',
			5212200: 'https://images.products.tctc.se/avlx6mr17s85q0fz829v73zbehv7mqfd_292_292_tr.webp',
			5213000: 'https://images.products.tctc.se/764lhdm4urpw99jdf299fty65d4fzkre_292_292_tr.webp',
			5211400: 'https://images.products.tctc.se/5bux9qwua67i0kzhsngwc0zcvv5fb5if_292_292_tr.webp',

			// städ & hygien
			5218800: 'https://images.products.tctc.se/y8t1hr35r82nyo2eibk4kd7ady9bq9ug_292_292_tr.webp',
			5219400: 'https://images.products.tctc.se/izncbdrijz9gi6x0meck4dydv6w5i71x_292_292_tr.webp',
			5216600: 'https://images.products.tctc.se/ldk2b8ib97yyu7bsf7sirlx393f3bl8g_292_292_tr.webp',
			5216000: 'https://images.products.tctc.se/j6b28lbvhrf1hdv22j1w8up6t89n6tc1_292_292_tr.webp',
			5218200: 'https://images.products.tctc.se/f4p6pr0mrk16h6zz4wn6ndz3hs2va7u1_292_292_tr.webp',
			5216800: 'https://images.products.tctc.se/w52msklmuag2wlq2zluknlvmn1pimm2i_292_292_tr.webp',
			5215000: 'https://images.products.tctc.se/4kpljunvn2j8s1irw0nz63b38c0x1c9l_292_292_tr.webp',
			5218000: 'https://images.products.tctc.se/twdja9ci9kohbxcu947jtv33wp58cr2n_292_292_tr.webp',

			// skydd & sjukvård
			8112861: 'https://images.products.tctc.se/l4rmng6j63fr5a3vtsq1ft7oii27ytcr_292_292_tr.webp',
			8113160: 'https://images.products.tctc.se/javweoofpwhe41zjpouu8x5q3ebgz2at_292_292_tr.webp',

			// skola & hobby
			5901100: 'https://images.products.tctc.se/9l7zxir4s39988ukzcn52w6dp68newl4_292_292_tr.webp',
			5901500: 'https://images.products.tctc.se/xiusorumc8xub99dvp18ulfnvcew3bi9_292_292_tr.webp',
			5901700: 'https://images.products.tctc.se/jw60np4nc2f3a6wavhy6fkpyn2rkuzcl_292_292_tr.webp',
			5901800: 'https://images.products.tctc.se/unlyprpnw97flv7w2g03t82ghsuug2e3_292_292_tr.webp',
			5902000: 'https://images.products.tctc.se/hgvsqwshyafj1rkg94fohwuvy5blll65_292_292_tr.webp',
			5902200: 'https://images.products.tctc.se/yuvgvehx0s9lhyb69nzu02sg64t76usk_292_292_tr.webp',
			8110635: 'https://images.products.tctc.se/zu609w03zj3lwesp2pzcfp1a0awzwjzm_292_292_tr.webp',
			8110762: 'https://images.products.tctc.se/zg7s6xij1qswzood3jd63ydisymleteg_292_292_tr.webp',
			8110769: 'https://images.products.tctc.se/1mvuv0ny0k03zfg18s9u76hatp2knle9_292_292_tr.webp',

			// möbler & belysning
			5531400: 'https://images.products.tctc.se/wp56rr85a0jcdhwog8272bxkj9pnusdn_292_292_tr.webp',
			5532200: 'https://images.products.tctc.se/b4hz8a5i0cav1e0x1o2n6d69xlfe0bge_292_292_tr.webp',
			5532300: 'https://images.products.tctc.se/40bgrgm7x2limp0coihbda78vwlzpfna_292_292_tr.webp',
			5532600: 'https://images.products.tctc.se/q1kn4hr7bwewgbtd9k0gnjqsfrr2e3s4_292_292_tr.webp',
			5533000: 'https://images.products.tctc.se/3b70zruwqmlnlvux0muhy4cn1gtnbo98_292_292_tr.webp',
			8110657: 'https://images.products.tctc.se/kwk87rcpl46dhpl5yp25q816n0uqmlf5_292_292_tr.webp',
			8110978: 'https://images.products.tctc.se/crml26mxzqgde8gl7nvgbcc3cm6ihrit_292_292_tr.webp',
			8112878: 'https://images.products.tctc.se/qduqvsqdnjpjzfjm0dn4tpfudauzjxaw_292_292_tr.webp',
			8112929: 'https://images.products.tctc.se/rps7di9535b1q6gqjao3grwxdevmaq6h_292_292_tr.webp',
			8113079: 'https://images.products.tctc.se/5pfyea0ytvzrtf5rxcnk3kg7ey3s04di_292_292_tr.webp',
		},
		kgno: {
			// kontor & pappir
			8112451: 'https://images.products.tctc.se/yz3lfav8hfiw30m565eq49rvzlktg49y_292_292_tr.webp',
			8112476: 'https://images.products.tctc.se/86nu283nkgqp6tvsdy4xgcmcxq77ltie_292_292_tr.webp',
			8112540: 'https://images.products.tctc.se/7c9otied21xwago7zew0kgmcmyyfn6ol_292_292_tr.webp',
			8112583: 'https://images.products.tctc.se/b7su24huerfo769s1b5dp384mg61kx18_292_292_tr.webp',
			8112620: '/images/category-card-papper-etiketter.png',
			8112652: 'https://images.products.tctc.se/s13wlr0v5c16i01danqfqe7cjgktq8ci_292_292_tr.webp',
			8112683: 'https://images.products.tctc.se/gcozmh84zgoag9xnzdg595gi4elnocve_292_292_tr.webp',
			8112734: 'https://images.products.tctc.se/acsfv0svll8j6kw34dmqlolkbjtg02as_292_292_tr.webp',
			8112753: 'https://images.products.tctc.se/antwbpvacua6jlh7zf81667fuvn6bsd6_292_292_tr.webp',
			8112762: 'https://images.products.tctc.se/2qdbm6u0ixb1nuq3gh5ng3gp13kesv11_292_292_tr.webp',
			8112797: 'https://images.products.tctc.se/h8vmc1aqo1blq7id3p00qq15zs30uo8s_292_292_tr.webp',
			8112813: 'https://images.products.tctc.se/aag5pfi62pevgnly9fay5x3up2p5jtwm_292_292_tr.webp',
			8112913: 'https://images.products.tctc.se/gl70jtdzm07bsahvyemd5c3191xqwmh6_292_292_tr.webp',

			// pakking & post
			8112028: 'https://images.products.tctc.se/hnqdm9p4k3uyoz9y987d3mpwlx9tz12q_292_292_tr.webp',
			8112066: 'https://images.products.tctc.se/3qdmtraxw0ocp3ntu2rcokah45j032ep_292_292_tr.webp',
			8112079: 'https://images.products.tctc.se/zygqcjdexkzmrnluvw514909g3hds5zf_292_292_tr.webp',

			// kjokken & drikke
			8112035: 'https://images.products.tctc.se/3a5ela2qnm8j8iarzn7fh7mv5fpd6gix_292_292_tr.webp',
			8112117: 'https://images.products.tctc.se/b6g8yf3msugycb549lq7f7jjcstxqi2h_292_292_tr.webp',
			8112119: 'https://images.products.tctc.se/c3z7tse56ad2nm8adxywju1657qqk72m_292_292_tr.webp',
			8112128: 'https://images.products.tctc.se/rz9sb22eq5cbppcgj0dp87o6h2vdh7q5_292_292_tr.webp',
			8112147: 'https://images.products.tctc.se/irf2svejpd2gsc6hwiggdzqpwib8e8sb_292_292_tr.webp',
			8112995: 'https://images.products.tctc.se/mlklesqrmbpj4cfopik8dkmj7bj9ima8_292_292_tr.webp',

			// skole & hobby
			8112230: 'https://images.products.tctc.se/5zrgo47zl9x4h99b79ymsk24sxwikwpm_292_292_tr.webp',
			8112267: 'https://images.products.tctc.se/f32egyg4j6q3yvidgmdlapl1mj50w46g_292_292_tr.webp',
			8112306: 'https://images.products.tctc.se/wkx5wyalj3k7mdbawnyi1pozmsb80sza_292_292_tr.webp',
			8112316: 'https://images.products.tctc.se/1noc50pzkjzyegg5ytja4d21zh0pexc8_292_292_tr.webp',
			8112949: 'https://images.products.tctc.se/zg7s6xij1qswzood3jd63ydisymleteg_292_292_tr.webp',

			// torkepapir & renhold
			8112165: 'https://images.products.tctc.se/e60czb165ze7x9hqb4j9aglveq2zn8rc_292_292_tr.webp',
			8112180: 'https://images.products.tctc.se/m3rne3htjjq1cylk3fan9s70ubli8wu3_292_292_tr.webp',
			8112190: 'https://images.products.tctc.se/56gh2rbc0cb8a4pi3rzjkdc1gvkn3z3z_292_292_tr.webp',
			8112196: 'https://images.products.tctc.se/2ssm5bkxyji3kxxfzvsa62lmb1gqo1jm_292_292_tr.webp',
			8112207: 'https://images.products.tctc.se/y8t1hr35r82nyo2eibk4kd7ady9bq9ug_292_292_tr.webp',
			8112210: 'https://images.products.tctc.se/a69hb9nd0qzcue7z7aiopobcjdvxxh34_292_292_tr.webp',
			8112216: 'https://images.products.tctc.se/67d8aqkyn8p8kdsz09th8n4trg7icyqv_292_292_tr.webp',
			8113031: 'https://images.products.tctc.se/bn5hf3d8230ius82izsaqnhextkkmyt4_292_292_tr.webp',

			// pleije & verneutstyr
			8112400: 'https://images.products.tctc.se/6wlg3rg2j4larcd6btw7ou3r4ko91wwk_292_292_tr.webp',
			8112413: 'https://images.products.tctc.se/gapmy778mkltg6n3lmf3nnqhws2bwye7_292_292_tr.webp',
		},
		kgdk: {
			// kontor och papir
			8113179: 'https://images.products.tctc.se/7vc5mc0xdqtwzr4uc92msawvb68uwof9_292_292_tr.webp',
			8113256: 'https://images.products.tctc.se/gcozmh84zgoag9xnzdg595gi4elnocve_292_292_tr.webp',
			8113378: 'https://images.products.tctc.se/yz3lfav8hfiw30m565eq49rvzlktg49y_292_292_tr.webp',
			8113403: 'https://images.products.tctc.se/q0bbdeslm0ghj3o1oxg4sd2n5oujwnxq_292_292_tr.webp',
			8113352: 'https://images.products.tctc.se/2tb512vj51vkjqhms0mztstmvm3pqibs_292_292_tr.webp',
			8113291: 'https://images.products.tctc.se/hmr3tydlv7ek4qflvcx42ojp3sessxux_292_292_tr.webp',
			8113389: 'https://images.products.tctc.se/gl70jtdzm07bsahvyemd5c3191xqwmh6_292_292_tr.webp',
			8113215: 'https://images.products.tctc.se/3vhztdf9gil154u9mgqu51wemfabu7my_292_292_tr.webp',
			8113195: 'https://images.products.tctc.se/g76k9a9c4xw0na5gwjs77ym0n10ber7r_292_292_tr.webp',
			8116315: 'https://images.products.tctc.se/gm1tj44i8e0rj11iba4dc19lbo79yz52_292_292_tr.webp',

			// elektronik
			8113440: 'https://images.products.tctc.se/cpg5hkrq9jqm62pgmiiu7sbryh9m3l1z_292_292_tr.webp',
			8113457: 'https://images.products.tctc.se/yfz52bdbinevqmu544vdvxn8p7gt192j_292_292_tr.webp',
			8113479: 'https://images.products.tctc.se/1b9mc2w9lnx6xbu5yuchjs7nc4tfb0bs_292_292_tr.webp',
			8113724: 'https://images.products.tctc.se/2kpyo1mlhu6e0iyojj6z6gb39bv53ftu_292_292_tr.webp',
			8113468: 'https://images.products.tctc.se/bldvj38ijyzqqlm2bh0fr51li4rpb71g_292_292_tr.webp',
			8113445: 'https://images.products.tctc.se/wxk51mn7yj7evubmgrku3x5v0tva3wl3_292_292_tr.webp',
			8113390: 'https://images.products.tctc.se/v8q2fjeysxsbqsl4wpdpxfly8klzscin_292_292_tr.webp',
			8113485: 'https://images.products.tctc.se/yqsvmxl6ucjq55vzq7mo9i2s3lww1ax8_292_292_tr.webp',
			8113489: 'https://images.products.tctc.se/4wo7edvmyf9ixsqo5ewugc2e84gjkqk7_292_292_tr.webp',
			8113722: 'https://images.products.tctc.se/va0pba3nnsi0zous6vis7jvpeloj3rkf_292_292_tr.webp',
			8113451: 'https://images.products.tctc.se/zwe4xf4n5ct7qjcu1so9gcytsoig7j80_292_292_tr.webp',
			8113494: 'https://images.products.tctc.se/biyia6r4qcnspxu6djm8ay5yl3s8tikw_292_292_tr.webp',
			8113859: 'https://images.products.tctc.se/ef3rw37fmc8hj0jr28gx6xxv2j1q6kts_292_292_tr.webp',
			8113975: 'https://images.products.tctc.se/ydlt9xu1ud7ychnk5w5z32acpm6kvfyl_292_292_tr.webp',
			8113808: 'https://images.products.tctc.se/fhlaoujxqmvqxhgia7gbd2h64v7zient_292_292_tr.webp',
			8113838: 'https://images.products.tctc.se/14f2p9dz5ow1fl0nsme9gpzm6zkb9hg5_292_292_tr.webp',
			8113821: 'https://images.products.tctc.se/mkt3fwq8hdpewhdie7w8m4szsl5nlrc1_292_292_tr.webp',
			8113757: 'https://images.products.tctc.se/e58aupqq3rqxmb4edi7uukbc3vqauti6_292_292_tr.webp',
			8113870: 'https://images.products.tctc.se/hvdozi7y0u1ezathaml598f85qh6fw40_292_292_tr.webp',

			// kokken & drikke
			8113537: 'https://images.products.tctc.se/mr4b6wec47ubtvw466qmmiay4175epgm_292_292_tr.webp',
			8113505: 'https://images.products.tctc.se/nkmk6keth906axcv9yoksr81dbkfev5v_292_292_tr.webp',
			8113520: 'https://images.products.tctc.se/v33x0vcq6hmihpe5t7007hqkcknum3dj_292_292_tr.webp',
			8113529: 'https://images.products.tctc.se/s0c1zrjtp8o11r3e5v6iz9bbadkxveud_292_292_tr.webp',
			8115086: 'https://images.products.tctc.se/gry1bqo1unbxz96rdow5indvhhj09oq2_292_292_tr.webp',

			// skole & hobby
			8113553: 'https://images.products.tctc.se/zu609w03zj3lwesp2pzcfp1a0awzwjzm_292_292_tr.webp',
			8113567: 'https://images.products.tctc.se/9l7zxir4s39988ukzcn52w6dp68newl4_292_292_tr.webp',
			8113583: 'https://images.products.tctc.se/unlyprpnw97flv7w2g03t82ghsuug2e3_292_292_tr.webp',
			8113578: 'https://images.products.tctc.se/zc2kubgz2ehzhxmpgpojwxru0smrg6o8_292_292_tr.webp',

			// rengoring og aftorring
			8113618: 'https://images.products.tctc.se/j6b28lbvhrf1hdv22j1w8up6t89n6tc1_292_292_tr.webp',
			8113616: 'https://images.products.tctc.se/y8t1hr35r82nyo2eibk4kd7ady9bq9ug_292_292_tr.webp',
			8113592: 'https://images.products.tctc.se/0r5x4c8wmjb59xfdevxq6kgw36ech79m_292_292_tr.webp',
			8113605: 'https://images.products.tctc.se/a0dz596lblfew9x3zr6gj0b4w4b7nxi6_292_292_tr.webp',
			8113719: 'https://images.products.tctc.se/izncbdrijz9gi6x0meck4dydv6w5i71x_292_292_tr.webp',
			8113622: 'https://images.products.tctc.se/lc41fq538tneljcmnfbbnobcrjozjewc_292_292_tr.webp',
			8113649: 'https://images.products.tctc.se/i0l6asj4czfprfd7grqf5q173fn2t60l_292_292_tr.webp',
			8113640: 'https://images.products.tctc.se/o5xj4jn2tdks1kz8676525nota1kp1co_292_292_tr.webp',
			8113611: 'https://images.products.tctc.se/g6g63s4a1ag9nc52t5lv9ttowrwe2sud_292_292_tr.webp',

			// værnemidler & tøj
			8113674: 'https://images.products.tctc.se/38dapga8acub06qjx44te64nxgstbl0r_292_292_tr.webp',
			8113686: 'https://images.products.tctc.se/bqqkfz2cu9r2cgmv51ly0bcgpdzwa61x_292_292_tr.webp',
			8113684: 'https://images.products.tctc.se/d4biajxld9cpo5bosm2h6vf8miq30zst_292_292_tr.webp',
			8113588: 'https://images.products.tctc.se/qi2v1yj4dq719sy2ejgbzx5zfjraw701_292_292_tr.webp',
			8113637: 'https://images.products.tctc.se/l4rmng6j63fr5a3vtsq1ft7oii27ytcr_292_292_tr.webp',
			8113680: 'https://images.products.tctc.se/rox7ygztuvtrvz8eig6v1b2p6j33lywg_292_292_tr.webp ',

			// kontorinredning
			8113341: 'https://images.products.tctc.se/hgq3tyw3s6kcs8isjuvb3zkj5cd477ct_292_292_tr.webp',
			8113716: 'https://images.products.tctc.se/rps7di9535b1q6gqjao3grwxdevmaq6h_292_292_tr.webp',
			8113325: 'https://images.products.tctc.se/y4ial8hxxbr6wllaed7dl201pjkijusy_292_292_tr.webp',
			8113312: 'https://images.products.tctc.se/3b70zruwqmlnlvux0muhy4cn1gtnbo98_292_292_tr.webp',
			8113329: 'https://images.products.tctc.se/tk23hk5w9p4qf22co1ddmgxoog2mra5w_292_292_tr.webp',
			8113345: 'https://images.products.tctc.se/i757khmidlnaw5n7y4ev6ece965p3k3e_292_292_tr.webp',
			8113315: 'https://images.products.tctc.se/ttleojzbpwjqezboa7i6tn82t7pxf3dh_292_292_tr.webp',
			8113755: 'https://images.products.tctc.se/m31ps9xsc01b34f1ymfj3a71mrsmk42d_292_292_tr.webp',
		},
		kgnl: {
			// kantoor & papier
			8114592: 'https://images.products.tctc.se/vtycrnur6xpqlmmwwymu5fh9f3k56q2y_292_292_tr.webp',
			8114639: 'https://images.products.tctc.se/7jj77r1cwkdjk1epf9lk749djoqxmbm8_292_292_tr.webp',
			8114139: 'https://images.products.tctc.se/p6pggqxkmn5ji77csts5tzcyu4dtkiu2_292_292_tr.webp',
			8115084: 'https://images.products.tctc.se/3mk6x9w3ly8t2dw56poghgir6i0x8cee_292_292_tr.webp',
			8114579: 'https://images.products.tctc.se/7mriubl1ujsyz578yrr22g9xgns9v8zg_292_292_tr.webp',
			8115083: 'https://images.products.tctc.se/vedxyeiqp912o92emlyu8zxffugpqorx_292_292_tr.webp',
			8114706: 'https://images.products.tctc.se/6txsr1ju2x2yqtaofcg5nngv84nlygqf_292_292_tr.webp',
			8114779: 'https://images.products.tctc.se/21tpc0v1e8gqm7z48ahuu2jc5q0bfb89_292_292_tr.webp',
			8114734: 'https://images.products.tctc.se/5nr8p67a7nmj6q9ttqbqx7amilwi9fbn_292_292_tr.webp',
			8114542: 'https://images.products.tctc.se/z9l4qlk9p9wsyaavpeapb3cpo4547nm2_292_292_tr.webp',
			8114521: 'https://images.products.tctc.se/n65clh36eqab3rfe8vmnwtt3vb4hz3bd_292_292_tr.webp',
			8114326: 'https://images.products.tctc.se/da7ickyvzi82oc4u444rju75k7nyyrja_292_292_tr.webp',

			// schoonmaak & hygiene
			8114160: 'https://images.products.tctc.se/y8t1hr35r82nyo2eibk4kd7ady9bq9ug_292_292_tr.webp',
			8114163: '', // Insectenbestrijding
			8114164: 'https://images.products.tctc.se/w0xvvxnwgoy3g37llez6p6945sq79udu_292_292_tr.webp',
			8114215: 'https://images.products.tctc.se/2oo9cymjygv42a160fda9khgbmnlzhoo_292_292_tr.webp',
			8114166: '', // Desinfectie & Meetapparatuur
			8114161: '', // Hygiëne
			8114313: 'https://images.products.tctc.se/fqmp312wj12pv464fp6rm9fknqjowhzr_292_292_tr.webp',
			8114165: 'https://images.products.tctc.se/ittnmna7u5vfcu6uwfg8j5mybou2k4ww_292_292_tr.webp',
			8114162: '', // Virusbescherming
			8114464: 'https://images.products.tctc.se/6g76yh0v9i1er5678sudytrp66vrffyb_292_292_tr.webp',

			// keuken & dranken
			8114206: 'https://images.products.tctc.se/9cy7thnau6o24yfz6wlfzfmtvedt656s_292_292_tr.webp',
			8114183: 'https://images.products.tctc.se/9xrcytqu2zc1owgluffwombw0ht5plzz_292_292_tr.webp',
			8114181: 'https://images.products.tctc.se/huhun5emm5e8e23zhm55fklhycorjtqm_292_292_tr.webp',
			8114185: 'https://images.products.tctc.se/lvc1rba7fm467t3ii9i68rkw9rna9fme_292_292_tr.webp',
			8114227: 'https://images.products.tctc.se/9b4dncdfkxd7iyyovad0oqbsywgjouj6_292_292_tr.webp',
			8114184: 'https://images.products.tctc.se/0vmwriaodct1fy0l2pvlk0awo604q4n6_292_292_tr.webp',
			8114186: 'https://images.products.tctc.se/caxa9ocg7dh9wj53zqr7yaronizwsuki_292_292_tr.webp',
			8114182: 'https://images.products.tctc.se/jul2scmoccot98m6zhc9uv2cjcze6vin_292_292_tr.webp',

			// school & hobby
			8114985: 'https://images.products.tctc.se/s99dmsowmfywkuyvnycpndf5d21gdje6_292_292_tr.webp',
			8115012: 'https://images.products.tctc.se/fcyjigspy83ygwwfbx4kgwws8gps0o3b_292_292_tr.webp',
			8114997: 'https://images.products.tctc.se/704h33q0i8qcbjk0bhqh1hsnqy4z8jfi_292_292_tr.webp',
			8115002: 'https://images.products.tctc.se/z9w0zmmtysz0685pwpijwyjvturznsmy_292_292_tr.webp',
			8115004: 'https://images.products.tctc.se/ebz7o67bvawzj81qc70ggf8p9x5zmlti_292_292_tr.webp',
			8115018: 'https://images.products.tctc.se/zh7jnztjzv7rq1xi6m7zbad12296c9qe_292_292_tr.webp',
			8115033: 'https://images.products.tctc.se/v32hbuqfjq8h8v4j2bm0fexyqsuoc883_292_292_tr.webp',
			8115038: 'https://images.products.tctc.se/nk0tiyqwrrve8lnl7y0i92jcyp1x86hy_292_292_tr.webp',
			8115041: 'https://images.products.tctc.se/rr3o36ahcq4tmf61bftl73qap8gx1ums_292_292_tr.webp',
			8115057: 'https://images.products.tctc.se/h107pwqu7c0pfkhti575o60cbangt3oy_292_292_tr.webp',
			8115065: 'https://images.products.tctc.se/uxtf47f31ahq58woop6h9vit404dcx12_292_292_tr.webp',
			8115028: 'https://images.products.tctc.se/ffb8amak5lljy8pp2w85nd0qftpngdb8_292_292_tr.webp',
			8115070: 'https://images.products.tctc.se/a3yhnan93ujv41ro3h893tjz4kyrb47f_292_292_tr.webp',
			8115081: 'https://images.products.tctc.se/ac3zv1ol1p28ogivjl9ha7w18t33qa8u_292_292_tr.webp',

			// kantoorinrichting
			8114881: 'https://images.products.tctc.se/ntbca4llwdl3x7c3lh1tro81dmqzzfgx_292_292_tr.webp',
			8114336: 'https://images.products.tctc.se/cbsaw7hbeze4ysamt4ofpgppbv9h8fr5_292_292_tr.webp',
			8114884: 'https://images.products.tctc.se/5uxc5ni2882hdyhgl3wmhxg0mf3smqx1_292_292_tr.webp',
			8114307: 'https://images.products.tctc.se/mvb9i63b6566bbwgch83o5nx0ig79xxd_292_292_tr.webp',
			8114893: 'https://images.products.tctc.se/z254w7j88q56o8cc2fz1dw67d809vm1q_292_292_tr.webp',
			8114895: 'https://images.products.tctc.se/49cgfkmbs9jrc07xqbaoeuya4rzc6kfo_292_292_tr.webp',
			8114296: 'https://images.products.tctc.se/n6h5pti83k5ejdimukr6p2vrw1jizkn7_292_292_tr.webp',
			8114289: 'https://images.products.tctc.se/x0fdxi9guako9yaach7oa91c62ljqjcu_292_292_tr.webp',
			8114901: 'https://images.products.tctc.se/0a7xhqfvlb799im16esu0hviwzsezafr_292_292_tr.webp',
			8114341: 'https://images.products.tctc.se/aaqdknu7yufubfyrhavfk81ru79aipue_292_292_tr.webp',
			8114332: 'https://images.products.tctc.se/edw2p3mpfqojomgswoq4vew4s17ksgos_292_292_tr.webp',

			// bescherming & verzorging
			8114515: 'https://images.products.tctc.se/qu5z06yaphbqo7idkna8w60zvqs653ok_292_292_tr.webp',
			8114537: 'https://images.products.tctc.se/qqnthe4h6trtnc7x4dee3fmld5ty4un4_292_292_tr.webp',
			8114176: 'https://images.products.tctc.se/ttqsyf8xcbxz0sdsvlcromz14igbyzm2_292_292_tr.webp',
			8114508: 'https://images.products.tctc.se/78kqgp7kjm0y1owva3u0p0mog6jsecms_292_292_tr.webp',
			8114444: 'https://images.products.tctc.se/2e01qu9jgs4cgvwh8gryr3odg0wj466n_292_292_tr.webp',
			8114528: 'https://images.products.tctc.se/vyij8e3fj9ky6rdtm0abp3bwmpeeli9f_292_292_tr.webp',
			8114255: 'https://images.products.tctc.se/ut3ifwz6dml46sp4a4sxgl8lwoxcz3yr_292_292_tr.webp',
			8114495: 'https://images.products.tctc.se/w8b013yszmrfmsm7o6oubgianzy8j2sb_292_292_tr.webp',

			// it & elektronica
			8114721: 'https://images.products.tctc.se/vwlnk0su3hlluuljcs57ia3szbype76p_292_292_tr.webp',
			8114171: 'https://images.products.tctc.se/3ybr41oh99m7wrnbqqw3tgdimex6itu0_292_292_tr.webp',
			8114948: 'https://images.products.tctc.se/9c7wex1mueiufio7kc6rwqr418l2ayv1_292_292_tr.webp',
			8114950: 'https://images.products.tctc.se/vueo69jzvu52zf3xqdjp5mgsf649w8w8_292_292_tr.webp',
			8114941: 'https://images.products.tctc.se/4dtailfqm4i458gs15h8j2975r1gtpfm_292_292_tr.webp',
			8114956: 'https://images.products.tctc.se/ocoswgkg0oq32s5rgo9zsn7itntow2is_292_292_tr.webp',
			8114720: 'https://images.products.tctc.se/thqe3ra6h3kjng9weu7c72b9807856kr_292_292_tr.webp',
			8114138: 'https://images.products.tctc.se/8zod0r8xgkc6q0fo1yp7pcsz9cb98chq_292_292_tr.webp',
			8114965: 'https://images.products.tctc.se/0frqsc3fsu8lp0z5p43mc6u4yn3fksjh_292_292_tr.webp',
			8114600: 'https://images.products.tctc.se/x18u304l6hi7uhutsk98anm02n713eye_292_292_tr.webp',
			8114320: 'https://images.products.tctc.se/8odrxn7g54j5buf4wmp7zy8wmrjv93pr_292_292_tr.webp',
			8114953: 'https://images.products.tctc.se/2y8id9wey9tzzgei93i6fgwwgz16me4n_292_292_tr.webp',
			8114976: 'https://images.products.tctc.se/ptuuwlhoiv2jroh7h7lhwd0v74ppntt0_292_292_tr.webp',
		},
		kgat: {},
		kgde: {},
		kggb: {},
	};

	return (
		<category-card title={category.name} class={'superCategory-' + category.parentId}>
			<Link to={'/' + category.perma}>
				<div className="heading-card">
					<div
						className="background-image"
						style={{ backgroundImage: `url(${categoryImages[store][category.id]})` }}
					></div>
					<h2>{category.name}</h2>
				</div>
			</Link>
			<ul>
				{category.children
					.sort(function (a, b) {
						return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
					})
					.map((e) => (
						<li key={e.id}>
							<Link to={'/' + e.perma}>{e.name}</Link>
						</li>
					))}
			</ul>
		</category-card>
	);
};
